import styled from "styled-components";

export const ToastWrapper = styled("div")`
    position: relative;
    z-index: 10001;
`;
